import React from "react";

export const LazyRedBoxPaletteInsertBridge = React.lazy(
    () => import(/* webpackChunkName: "RedBox" */ "./PaletteInsert")
);
